import { safeLocalStorageSetItem } from "utils/localStorage";

export const DEFAULT_POST_LOGIN_REDIRECT = "/org/environments";

export const POST_LOGIN_REDIRECT_STORAGE_KEY = "brev-redirect-url";

const REDIRECT_BASE_URL = "https://brev.local";
const NON_PERSISTED_REDIRECT_PATHS = new Set([
  "/",
  "/login",
  "/logout",
  "/redirecting-you-swiftly",
]);
const NON_PERSISTED_REDIRECT_PREFIXES = ["/error/"];

function parseLocalRedirect(pathAndSearch?: string | null): URL | null {
  if (!pathAndSearch) return null;

  try {
    const url = new URL(pathAndSearch, REDIRECT_BASE_URL);
    if (url.origin !== REDIRECT_BASE_URL) return null;
    return url;
  } catch {
    return null;
  }
}

export function shouldPersistPostLoginRedirect(pathname: string): boolean {
  return (
    !NON_PERSISTED_REDIRECT_PATHS.has(pathname) &&
    !NON_PERSISTED_REDIRECT_PREFIXES.some((prefix) =>
      pathname.startsWith(prefix),
    )
  );
}

export function sanitizePostLoginRedirect(
  pathAndSearch?: string | null,
): string | null {
  const url = parseLocalRedirect(pathAndSearch);
  if (!url || !shouldPersistPostLoginRedirect(url.pathname)) {
    return null;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}

export function getPostLoginRedirect(): string | null {
  return sanitizePostLoginRedirect(
    localStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY),
  );
}

export function getPostLoginRedirectOrDefault(): string {
  return getPostLoginRedirect() ?? DEFAULT_POST_LOGIN_REDIRECT;
}

export function setPostLoginRedirect(pathAndSearch: string): void {
  const redirectValue = sanitizePostLoginRedirect(pathAndSearch);
  if (!redirectValue) return;

  safeLocalStorageSetItem(POST_LOGIN_REDIRECT_STORAGE_KEY, redirectValue);
}

export function clearPostLoginRedirect(): void {
  window.localStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
}
